import React from 'react';
import { View } from 'react-native';

export const DefComp = props => {
  return <defs>{props.children}</defs>;
};

export const LinearGradientComp = props => {
  const { id, x1, y1, x2, y2, gradientUnits } = props;
  return (
    <linearGradient id={id} x1={x1} y1={y1} x2={x2} y2={y2} gradientUnits={gradientUnits}>
      {props.children}
    </linearGradient>
  );
};

export const StopComp = props => {
  const { offset, stopColor } = props;
  return <stop offset={offset} stopColor={stopColor} />;
};

export const CirlceComp = props => {
  const { cx, cy, r, fill, stroke, strokeWidth, strokeOpacity } = props;
  return (
    <circle cx={cx} cy={cy} r={r} stroke={stroke} strokeOpacity={strokeOpacity} strokeWidth={strokeWidth} fill={fill} />
  );
};

export const TextComp = props => {
  const { fontFamily, fontSize, fontWeight, transform } = props;
  return (
    <text fontFamily={fontFamily} fontWeight={fontWeight} fontSize={fontSize} transform={transform}>
      {props.children}
    </text>
  );
};
export const TextSComp = props => {
  const { x, y } = props;
  return (
    <tspan x={x} y={y}>
      {props.children}
    </tspan>
  );
};

export const PathComp = ({ d, fill, fillRule, stroke, strokeOpacity, strokeWidth, strokeLinecap, strokeLinejoin }) => {
  return (
    <path
      d={d}
      stroke={stroke}
      fill={fill}
      fillRule={fillRule}
      strokeOpacity={strokeOpacity}
      strokeWidth={strokeWidth}
      strokeLinecap={strokeLinecap}
      strokeLinejoin={strokeLinejoin}
    />
  );
};

export const GComp = props => {
  const { fill, fillRule } = props;
  return (
    <g fill={fill} fillRule={fillRule}>
      {props.children}
    </g>
  );
};

export const SVGComp = props => {
  const { width, height, viewBox, deg = '0', style } = props;
  return (
    <View style={[style, {transform: [{ rotate: `${deg}deg` }]}]}>
      <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill="none">
        {props.children}
      </svg>
    </View>
  );
};
